import { EAddMemberRelationship } from '@/types';
import type { FieldDescriptor } from '@/types/fieldDescriptor';

export const NOMINEE_FIELDS: FieldDescriptor[] = [
  {
    id: 'name',
    fieldType: 'TEXT',
    label: 'Nominee Name',
    placeholder: 'Enter nominee name',
    validation: {
      required: true,
      minLength: 1,
      errorMessage: 'Nominee name is required',
      pattern: '^[a-zA-Z\\s.]+$',
      patternMessage: 'Name cannot contain special characters',
    },
    layout: { sectionHeader: 'NOMINEE DETAILS', span: 'half' },
  },
  {
    id: 'relationship',
    fieldType: 'DROPDOWN',
    label: 'Relationship',
    placeholder: 'Select relationship',
    options: [
      { value: EAddMemberRelationship.Son, label: EAddMemberRelationship.Son },
      {
        value: EAddMemberRelationship.Daughter,
        label: EAddMemberRelationship.Daughter,
      },
      {
        value: EAddMemberRelationship.Father,
        label: EAddMemberRelationship.Father,
      },
      {
        value: EAddMemberRelationship.Mother,
        label: EAddMemberRelationship.Mother,
      },
      {
        value: EAddMemberRelationship.Spouse,
        label: EAddMemberRelationship.Spouse,
      },
    ],
    validation: {
      required: true,
      errorMessage: 'Please select a relationship',
    },
    layout: { span: 'half' },
  },
  {
    id: 'dateOfBirth',
    fieldType: 'DATE',
    label: 'Date of Birth',
    placeholder: 'Date of Birth',
    validation: {
      required: true,
      errorMessage: 'Nominee date of birth is required',
      disableFutureDates: true,
    },
    layout: { span: 'half' },
  },
];
